export default __webpack_public_path__ + "static/media/xroad.60d26b2f.png";